import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_is_a_factor_in_decisions_on_hiring_selec'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_is_a_factor_in_decisions_on_hiring_selec',
  name: 'Which of the following is a factor in decisions on hiring?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'RACE_ETHNIC_GROUP_SKIN_COLOR',
      text: 'Race / Ethnic Group / Skin Color',
      externalIds: [
        {
          id: 'disc-2--1',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'YES_NO',
        text: "Is an applicant's race / ethnic group / skin color factored into hiring decisions in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-20',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'SEX_GENDER',
      text: 'Sex / Gender',
      externalIds: [
        {
          id: 'disc-2--2',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'YES_NO',
        text: "Is an applicant's sex / gender factored into hiring decisions in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-21',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'RELIGION',
      text: 'Religion',
      externalIds: [
        {
          id: 'disc-2--3',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'YES_NO',
        text: "Is an applicant's religion factored into hiring decisions in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-22',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'POLITICAL_OPINION',
      text: 'Political Opinion',
      externalIds: [
        {
          id: 'disc-2--4',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'YES_NO',
        text: "Is an applicant's political opinion factored into hiring decisions in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-23',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NATIONAL_EXTRACTION',
      text: 'National Extraction',
      externalIds: [
        {
          id: 'disc-2--5',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'YES_NO',
        text: "Is an applicant's national extraction factored into hiring decisions in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-24',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'SOCIAL_ORIGIN',
      text: 'Social Origin',
      externalIds: [
        {
          id: 'disc-2--6',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'YES_NO',
        text: "Is an applicant's social origin factored into hiring decisions in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-25',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'HIV_AIDS_STATUS_REAL_OR_PERCEIVED_',
      text: 'HIV / AIDS Status (real or perceived)',
      externalIds: [
        {
          id: 'disc-2--8',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SELECT',
        text: "Is an applicant's HIV / AIDS status factored into hiring decisions in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-26',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'SEXUAL_ORIENTATION',
      text: 'Sexual Orientation',
      externalIds: [
        {
          id: 'disc-2--9',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SELECT',
        text: "Is an applicant's sexual orientation factored into hiring decisions in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-27',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'PREGNANCY_MATERNITY_STATUS',
      text: 'Pregnancy / Maternity Status',
      externalIds: [
        {
          id: 'disc-2--10',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'YES_NO',
        text: "Is an applicant's pregnancy / maternity status factored into hiring decisions in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-28',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'MARITAL_STATUS',
      text: 'Marital Status',
      externalIds: [
        {
          id: 'disc-2--11',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SELECT',
        text: "Is an applicant's marital status factored into hiring decisions in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-29',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'AGE',
      text: 'Age',
      externalIds: [
        {
          id: 'disc-2--12',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SELECT',
        text: "Is an applicant's age factored into hiring decisions in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-30',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NATIONALITY_FOREIGN_MIGRANT_WORKER_STATUS',
      text: 'Nationality / Foreign Migrant Worker Status',
      externalIds: [
        {
          id: 'disc-2--13',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SELECT',
        text: "Is an applicant's nationality/foreign migrant status factored into hiring decisions in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-31',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FAMILY_RESPONSIBILITIES',
      text: 'Family responsibilities',
      externalIds: [
        {
          id: 'rh-dis-32x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SELECT',
        text: "Are an applicant's family responsibilities factored into hiring decisions in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-33',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'INDONESIA_DOES_THE_FACILITY_COMPLY_WITH_LEGAL_REQUIREMENTS_CONC1',
      text: 'Indonesia: Does the facility comply with legal requirements concerning premium compensation for non-permanent workers?',
      externalIds: [
        {
          id: 'wb-wag-101',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'IF_YES_DOES_THE_FACILITY_OR_RECRUITING_AGENCY_EVER_REQUEST_THAT',
      text: 'If yes, does the facility (or recruiting agency) ever request that foreign migrants sign a new contract once they are in their host country?',
      externalIds: [
        {
          id: 'ep-4--1',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'VIETNAM_DOES_THE_FACILITY_COMPLY_WITH_LEGAL_REQUIREMENTS_CONCER1',
      text: 'Vietnam: Does the facility comply with legal requirements concerning dispatched workers at the workplace?',
      externalIds: [
        {
          id: 'rh-emp-10',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'INDONESIA_DOES_THE_FACILITY_COMPLY_WITH_LEGAL_REQUIREMENTS_CONC2',
      text: 'Indonesia: Does the facility comply with legal requirements concerning outsourced workers at the workplace?',
      externalIds: [
        {
          id: 'rh-emp-11',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CAMBODIA_DOES_THE_FACILITY_INCLUDE_THE_ENTIRE_PERIOD_OF_CONTINU',
      text: "Cambodia: Does the facility include the entire period of continuous employment, as legally required, when determining workers' entitlements to maternity leave, attendance bonus, seniority bonus, and/or annual leave?",
      externalIds: [
        {
          id: 'rh-emp-12',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'VIETNAM_DOES_THE_FACILITY_COMPLY_WITH_LEGAL_REQUIREMENTS_CONCER2',
      text: 'Vietnam: Does the facility comply with legal requirements concerning breaks for shift work? ',
      externalIds: [
        {
          id: 'wh-wor-19',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If yes, please select all the categories of workers for which any workers in the category did not receive at least the legal minimum wage:',
        externalIds: [
          {
            id: 'wb-wag-6',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'PERMANENT_WORKERS',
      text: 'Permanent workers',
      externalIds: [
        {
          id: 'wb-wage-3',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'TEMPORARY_WORKERS',
      text: 'Temporary workers',
      externalIds: [
        {
          id: 'wb-wage-4',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CASUAL_WORKERS',
      text: 'Casual workers',
      externalIds: [
        {
          id: 'wb-wage-5',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PART_TIME_WORKERS',
      text: 'Part-time workers',
      externalIds: [
        {
          id: 'wb-wag-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'AGENCY_CONTRACT_WORKERS',
      text: 'Agency/contract workers',
      externalIds: [
        {
          id: 'wb-wag-8x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CONTRACT_WORKERS_WHO_ARE_NOT_PART_OF_THE_PRODUCTION_PROCESS',
      text: 'Contract workers who are not part of the production process',
      externalIds: [
        {
          id: 'wb-wag-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_UNDER_PROBATION',
      text: 'Workers under probation',
      externalIds: [
        {
          id: 'wb-wag-10x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_WHO_ARE_TRAINEES_APPRENTICES_OR_INTERNS',
      text: 'Workers who are trainees, apprentices or interns',
      externalIds: [
        {
          id: 'wb-wag-11x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'wb-wag-91x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'wb-wag-92f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'RACE_ETHNIC_GROUP_SKIN_COLOR',
                'SEX_GENDER',
                'RELIGION',
                'POLITICAL_OPINION',
                'NATIONAL_EXTRACTION',
                'SOCIAL_ORIGIN',
                'HIV_AIDS_STATUS_REAL_OR_PERCEIVED_',
                'SEXUAL_ORIENTATION',
                'PREGNANCY_MATERNITY_STATUS',
                'MARITAL_STATUS',
                'AGE',
                'NATIONALITY_FOREIGN_MIGRANT_WORKER_STATUS',
                'FAMILY_RESPONSIBILITIES',
                'INDONESIA_DOES_THE_FACILITY_COMPLY_WITH_LEGAL_REQUIREMENTS_CONC1',
                'IF_YES_DOES_THE_FACILITY_OR_RECRUITING_AGENCY_EVER_REQUEST_THAT',
                'VIETNAM_DOES_THE_FACILITY_COMPLY_WITH_LEGAL_REQUIREMENTS_CONCER1',
                'INDONESIA_DOES_THE_FACILITY_COMPLY_WITH_LEGAL_REQUIREMENTS_CONC2',
                'CAMBODIA_DOES_THE_FACILITY_INCLUDE_THE_ENTIRE_PERIOD_OF_CONTINU',
                'VIETNAM_DOES_THE_FACILITY_COMPLY_WITH_LEGAL_REQUIREMENTS_CONCER2',
                'PERMANENT_WORKERS',
                'TEMPORARY_WORKERS',
                'CASUAL_WORKERS',
                'PART_TIME_WORKERS',
                'AGENCY_CONTRACT_WORKERS',
                'CONTRACT_WORKERS_WHO_ARE_NOT_PART_OF_THE_PRODUCTION_PROCESS',
                'WORKERS_UNDER_PROBATION',
                'WORKERS_WHO_ARE_TRAINEES_APPRENTICES_OR_INTERNS',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'disc-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 5470,
  sectionId: '2.2.5',
  impactArea: 'Discrimination, Violence or Harassment',
  impactAreaId: 'DISCRIMINATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
